import React, { useState } from 'react'
import Modal from 'components/Modal'
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined'
import Button from 'components/Button'
import { useDispatch } from 'react-redux'
import { markStudentAsReady } from 'services/StudentsService'
import { getActiveStudentsRoutine } from 'modules/students/ducks/actions'
import { isNotNilOrEmpty } from 'utils/ramda'
import styled from 'styled-components'
import { Tooltip } from '@mui/material'

const MarkStudentAsReadyModal = ({ student, actionCallback }) => {
  const [open, setOpen] = useState(false)
  const dispatch = useDispatch()

  const handleOpen = e => {
    e.stopPropagation()
    setOpen(true)
  }

  const handleClose = e => {
    e && e.stopPropagation()
    setOpen(false)
  }

  const handleConfirm = () => {
    markStudentAsReady({
      student,
      callback: () => {
        isNotNilOrEmpty(actionCallback) ? actionCallback() : dispatch(getActiveStudentsRoutine())
        handleClose()
      }
    })
  }

  return (
    <>
      <Trigger onClick={handleOpen}>
        <Tooltip title='Gotowy do zajęć'>
          <StyledIcon />
        </Tooltip>
      </Trigger>
      <Modal
        title='Gotowy do zajęć'
        open={open}
        onClose={handleClose}
      >
        <Content>
          Czy uczeń <StudentName>{student.name}</StudentName> jest już gotowy do zajęć?
        </Content>
        <ButtonsWrapper>
          <Button onClick={handleClose} color='secondary'>Anuluj</Button>
          <Button color='primary' onClick={handleConfirm}>Potwierdź</Button>
        </ButtonsWrapper>
      </Modal>
    </>
  )
}

export default MarkStudentAsReadyModal

const Trigger = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`

const StyledIcon = styled(TaskAltOutlinedIcon)`
  transition: all .3s;

  &:hover {
    color: ${({ theme }) => theme.colors.secondary.main};
  }
`

const Content = styled.div`
  margin-bottom: 20px;
`

const StudentName = styled.span`
  color: ${({ theme }) => theme.colors.secondary.main};
  font-weight: bold;
`

const ButtonsWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
`
